import React from "react";

const B2B2ProductInfo = [
    {
        "packageType": "B2B_PACK_M2M",
        "cardDisplayName": <>Bisnes <br/> laitenetti</>,
        "sellingPoints": [
            <>Nopea<br/>uplink laitteille</>,
            'Rajaton data',
            '0,5 Mbit/s lataus, 5 Mbit/s lähetys',
            'Toimii vain Suomessa',
            'Liittymään voi soittaa. Lähtevät puhelut on estetty'
        ],
    },
    {
        "packageType": "B2B_PACK_4G_BASIC_MOIPOT",
        "cardDisplayName": <>Bisnes <br/> Potti 4G</>,
        "sellingPoints": [
            <>Edullinen<br/>kestosuosikki</>,
            '6 Gt jaettavaa dataa 100 Mbit/s',
            '14 Gt EU-roamingia kuukaudessa',
            'Lisädata 1,25 €/alkava Gt (enintään +12,50 €/kk)',
            'Puhe ja SMS max. 4 €/kk'
        ],
    },
    {
        "packageType": "B2B_PACK_4G_UNLIMITED",
        "cardDisplayName": <>Rajaton <br/> Bisnes 4G</>,
        "sellingPoints": [
            <>Rajaton ja nopea.<br/>Siis huippudiili!</>,
            'Rajaton data',
            '200 Mbit/s',
            '27 Gt EU-roamingia kuukaudessa',
            'Puhe ja SMS max. 4 €/kk'
        ],
    },
    {
        "packageType": "B2B_PACK_5G_400_4G_DISCOUNT",
        "cardDisplayName": <>Reilu <br/> Bisnes 5G</>,
        "sellingPoints": [
            <>Joustavasti  5G-<br/>ja 4G-verkossa</>,
            'Rajaton data',
            '400 Mbit/s',
            '40 Gt EU-roamingia kuukaudessa',
            'Puhe ja SMS max. 4 €/kk'
        ],
    },
    {
        "packageType": "B2B_PACK_5G_1000_4G_DISCOUNT",
        "cardDisplayName": <>Reilu <br/> Bisnes 5G</>,
        "sellingPoints": [
            <>Joustavasti  5G-<br/>ja 4G-verkossa</>,
            'Rajaton data',
            '1000 Mbit/s',
            '64 Gt EU-roamingia kuukaudessa',
            'Puhe ja SMS max. 4 €/kk'
        ],
    }
];

export const getCardDisplayName = (packageType) => {
    let product = B2B2ProductInfo.filter(item => (packageType === item.packageType));
    return product[0].cardDisplayName;
}

export const getSellingPoints = (packageType) => {
    let product = B2B2ProductInfo.filter(item => (packageType === item.packageType));
    return product[0].sellingPoints;
}